import React from 'react';
import { ISmartProps } from './types';
import { View } from './view';
import { withTooltip } from '../../Utilities/hoc/withTooltip';

export type ButtonProps = Omit<Omit<ISmartProps, 'css'>, '$style'>;

export const Button = React.forwardRef((props: ButtonProps, ref: any) => {
	return <View {...props} ref={ref} />;
});

export const TButton = withTooltip(Button);
